import { Link, NavLink, Outlet, useLocation } from 'react-router-dom'
import './People.css'

function PeopleDashboard() {
  return (
    <div className="people-dashboard">
      {/* Inactive State */}
      <div className="inactive-state">
        <div className="inactive-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
        </div>
        <h2 className="inactive-title">HR & Payroll is not active</h2>
        <p className="inactive-description">
          Manage employees, run payroll, track time off, and stay compliant with Hubthrill People.
        </p>
        
        <div className="features-grid">
          <div className="feature-item">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
              <circle cx="12" cy="7" r="4"/>
            </svg>
            <div>
              <span className="feature-title">Employee Directory</span>
              <span className="feature-desc">Centralized employee records</span>
            </div>
          </div>
          <div className="feature-item">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="12" y1="1" x2="12" y2="23"/>
              <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
            </svg>
            <div>
              <span className="feature-title">Payroll Processing</span>
              <span className="feature-desc">Run payroll in minutes</span>
            </div>
          </div>
          <div className="feature-item">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
              <line x1="16" y1="2" x2="16" y2="6"/>
              <line x1="8" y1="2" x2="8" y2="6"/>
              <line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
            <div>
              <span className="feature-title">Time Off Management</span>
              <span className="feature-desc">PTO tracking and approvals</span>
            </div>
          </div>
          <div className="feature-item">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
              <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
            </svg>
            <div>
              <span className="feature-title">Keeply Integration</span>
              <span className="feature-desc">Payroll costs sync to accounting</span>
            </div>
          </div>
        </div>

        <div className="pricing-info">
          <div className="pricing-header">
            <span className="pricing-label">Pricing</span>
            <span className="pricing-badge">Per employee</span>
          </div>
          <div className="pricing-details">
            <div className="pricing-item">
              <span>Base</span>
              <span>$6/employee/month</span>
            </div>
            <div className="pricing-item">
              <span>Payroll add-on</span>
              <span>+$4/employee/month</span>
            </div>
            <div className="pricing-item">
              <span>Tax filing</span>
              <span>Included</span>
            </div>
          </div>
        </div>

        <button className="btn btn-primary btn-large">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M5 12h14"/>
            <path d="M12 5v14"/>
          </svg>
          Activate People
        </button>

        <p className="activate-note">
          Payroll costs automatically flow into Keeply for seamless financial tracking.
        </p>
      </div>
    </div>
  )
}

function People() {
  const location = useLocation()
  const isOverview = location.pathname === '/dashboard/people'

  const subRoutes = [
    { name: 'Overview', path: '/dashboard/people', end: true },
    { name: 'Employees', path: '/dashboard/people/employees' },
    { name: 'Payroll', path: '/dashboard/people/payroll' },
    { name: 'Time Off', path: '/dashboard/people/time-off' },
    { name: 'Documents', path: '/dashboard/people/documents' }
  ]

  return (
    <div className="people-page">
      {/* Header */}
      <div className="page-header">
        <div className="header-info">
          <div className="module-badge people inactive">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
              <circle cx="9" cy="7" r="4"/>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
          </div>
          <div>
            <h1 className="page-title">HR & Payroll</h1>
            <p className="page-subtitle">People · Employee management platform</p>
          </div>
        </div>
        <div className="header-badge inactive">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
          </svg>
          Module not active
        </div>
      </div>

      {/* Sub Navigation (disabled) */}
      <nav className="sub-nav disabled">
        {subRoutes.map(route => (
          <span key={route.path} className="sub-nav-link disabled">
            {route.name}
          </span>
        ))}
      </nav>

      {/* Content */}
      {isOverview ? <PeopleDashboard /> : <Outlet />}
    </div>
  )
}

export default People
